module.exports = __webpack_public_path__ + "static/media/flag-sm.84461a84.webp";